// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__37OCm","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3-1wB","obliqueLine":"membershipbadge_obliqueLine__MiSOA"};